module.exports = __webpack_public_path__ + "img/bank-women.eed4039d.svg";